import axiosConfig from "./axiosConfig";
import { SelectedOrg } from "./postLeadSearch";

export interface VoaReviewRequest {
  selectedBuildingBkey?: string | null;
  selectedLandlord?: SelectedOrg | null;
  selectedTenant?: SelectedOrg | null;
  ownerOccupier?: boolean;
  // Operator-flagged existing rooftop solar, carried into the lead at promotion.
  hasPv?: boolean;
}

export interface VoaReviewResponse {
  reviewedAt: string;
  reviewedBy: string;
}

const patchVoaReview = async (
  authToken: string,
  sourceRef: string,
  body: VoaReviewRequest
): Promise<VoaReviewResponse> => {
  const { data } = await axiosConfig.patch(
    `/leads/voa/${encodeURIComponent(sourceRef)}/review`,
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default patchVoaReview;
